import React, { useEffect } from 'react'
import { ColorToHex } from '../../utility.js'
import './index.css'

const CognitoForm = ({ data, id }) => {
  useEffect(() => {
    window.Cognito?.mount(String(data?.primary?.form_id_number || id), `#cognitoForm`)
  }, [])

  const style = {
    color: ColorToHex('Zoo Blue'),
  }

  return <div className={`cognito cognitoForm`} id={`cognitoForm`}></div>
}

export default CognitoForm
